import { render, staticRenderFns } from "./LanguageCreateUpdate.vue?vue&type=template&id=0307df86&scoped=true&"
import script from "./LanguageCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./LanguageCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./LanguageCreateUpdate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LanguageCreateUpdate.vue?vue&type=style&index=1&id=0307df86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0307df86",
  null
  
)

export default component.exports